(function () {

    'use strict';

    angular.module('iplusjs.filter.adresse', [
        'iplusjs.utils.misc',
        'iplusjs.utils.format'
    ])
        .filter('adresseString', AdresseString);

    AdresseString.$inject = [
        'FormatUtilsService',
        'MiscUtilsService'
    ];
    function AdresseString(FormatUtilsService, MiscUtilsService) {
        return function (adresse, style, country, htmlStyle, highlightedProperties) {
            var options = {};

            if (MiscUtilsService.isEmpty(adresse) || typeof adresse !== 'object') {
                return '';
            }

            highlightedProperties = highlightedProperties || [];

            options.style = style;
            options.country = country;
            options.highlightedProperties = highlightedProperties;

            if (htmlStyle) {
                options.lineBreak = '<br>';
            }

            return FormatUtilsService.toAdresseString(adresse, options);
        };
    }
})();
